import { axiosDefault } from '@/core/utils';
import { Friend, FriendModel } from '@/core/interfaces';
import { UserFriendsMapper } from '@/core/mappers';

const getFriends = async (): Promise<Friend[]> => {
	const url = `/tg/user/friends`;
	const response = await axiosDefault.get(url);

	let friends: Friend[] = [];
	response.data.forEach((friend: FriendModel) => {
		friends.push(UserFriendsMapper(friend));
	});

	return friends;
};

export const FriendsService = {
	getFriends,
};
